import {buildInternalUrl} from '@flexinet/analytics-components';

const SOURCE = 'marketing-site';

export const internalUrl = (
    baseUrl: string,
    opts: { campaign: string; content?: string; term?: string },
): string =>
    buildInternalUrl(baseUrl, {source: SOURCE, ...opts});
